/* ============================================================
   PA • Wholesale Calculator
   Pure front-end calculation — no backend. Reads product data
   (retail + per-unit price at each tier) from a JSON data
   attribute rendered by Liquid from the section's blocks, so
   merchants can edit prices in the theme editor without
   touching this file.
   ============================================================ */
(function () {
  'use strict';

  var TIER_QTY = { tier1: 10, tier2: 25 };

  function money(n) {
    return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function PAWholesaleCalculator(root) {
    this.root = root;
    try {
      this.products = JSON.parse(root.dataset.products || '[]');
    } catch (e) {
      this.products = [];
    }

    this.productSelect = root.querySelector('[data-calc-product]');
    this.tierSelect = root.querySelector('[data-calc-tier]');
    this.calcBtn = root.querySelector('[data-calc-button]');

    this.costEl = root.querySelector('[data-calc-cost]');
    this.totalEl = root.querySelector('[data-calc-total]');
    this.retailEl = root.querySelector('[data-calc-retail]');
    this.marginEl = root.querySelector('[data-calc-margin]');

    if (!this.products.length || !this.productSelect || !this.tierSelect) return;

    this._populateProducts();
    this._bind();
    this._calculate();
  }

  PAWholesaleCalculator.prototype._populateProducts = function () {
    var self = this;
    this.productSelect.innerHTML = '';
    this.products.forEach(function (p, i) {
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = p.name;
      self.productSelect.appendChild(opt);
    });
  };

  PAWholesaleCalculator.prototype._bind = function () {
    var self = this;
    this.productSelect.addEventListener('change', function () { self._calculate(); });
    this.tierSelect.addEventListener('change', function () { self._calculate(); });
    if (this.calcBtn) {
      this.calcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self._calculate();
      });
    }
  };

  PAWholesaleCalculator.prototype._calculate = function () {
    var product = this.products[Number(this.productSelect.value)];
    if (!product) return;

    var tierKey = this.tierSelect.value === 'tier2' ? 'tier2' : 'tier1';
    var unitCost = Number(product[tierKey]) || 0;
    var retail = Number(product.retail) || 0;
    var qty = TIER_QTY[tierKey];

    var totalCost = unitCost * qty;
    var retailValue = retail * qty;
    var margin = retail > 0 ? ((retail - unitCost) / retail) * 100 : 0;

    if (this.costEl) this.costEl.textContent = money(unitCost);
    if (this.totalEl) this.totalEl.textContent = money(totalCost) + ' (' + qty + ')';
    if (this.retailEl) this.retailEl.textContent = money(retailValue) + ' (' + qty + ')';
    if (this.marginEl) this.marginEl.textContent = margin.toFixed(1) + '%';
  };

  function boot() {
    document.querySelectorAll('[data-wholesale-calculator]').forEach(function (el) {
      new PAWholesaleCalculator(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
